import React from 'react'
import {SystemMessageUtils} from 'yougile-model'
import {AssignmentSystemMessage} from './assignment-system-message'
import {DeadlineSystemMessage} from './deadline-system-message'
import {GtdSystemMessage} from './gtd-system-message'
import {MoveSystemMessage} from './move-system-message'
import {SystemMessageProps} from './types'

export const SystemMessage = ({
  message,
  className,
  animateShow
}: SystemMessageProps) => {
  let Component: any
  if (SystemMessageUtils.isAssignment(message)) {
    Component = AssignmentSystemMessage
  } else if (SystemMessageUtils.isGtd(message)) {
    Component = GtdSystemMessage
  } else if (SystemMessageUtils.isMove(message)) {
    Component = MoveSystemMessage
  } else if (
    SystemMessageUtils.isDeadlineNotice(message) ||
    SystemMessageUtils.isDeadline(message)
  ) {
    Component = DeadlineSystemMessage
  }

  return Component ? (
    <Component
      key={message.timestamp}
      message={message}
      className={className}
      animateShow={animateShow}
    />
  ) : null
}
